import createTableStore from "ds/components/Table/store/useTableStore";

import { SCANS_COLUMN_CONFIG, SCANS_COLUMNS_STORAGE_KEY } from "./constants";

const useScansTableStore = createTableStore({
  storageKey: SCANS_COLUMNS_STORAGE_KEY,
  config: SCANS_COLUMN_CONFIG,
  version: 3,
});

export default useScansTableStore;
